import { Injectable, inject } from '@angular/core';
import { CollectionRequestBuilder } from '@web/common';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { AdminShippingApiService } from '../api/services/admin-shipping-api.service';
import { AdminShippingMethodCollectionItemResponse } from '../api/responses/admin-shipping-method-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminShippingMethodSelectItemsProviderService {
  private readonly shippingApi = inject(AdminShippingApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public fetchSelectItems<
    Key extends keyof AdminShippingMethodCollectionItemResponse,
  >(
    key: Key,
  ): Observable<SelectItem<AdminShippingMethodCollectionItemResponse[Key]>[]> {
    /* prettier-ignore */
    return this.shippingApi
      .fetchCollection({
        request: this.collectionRequestBuilder
          .disablePagination()
          .build(),
        skipByLoading: true,
        cacheable: true,
      })
      .pipe(
        map((response) =>
          response.items.map((item) => new SelectItem(item.name, item[key])),
        ),
        catchError(() => of([])),
      );
  }
}
